import * as React from 'react'
import { Row, Col } from 'reactstrap'

import * as UserService from './../services/UserService'
import { AccentCheckUnbound } from './../controls/unbound/AccentCheckUnbound'
import { AccentDialog } from './AccentDialog'
import { AccentButton } from '../controls/AccentButton'
import { t } from '../services/HelperService'




export class MFReleaseDlg extends React.Component {

    constructor(props) {
        super(props)


        // workOrder: the supplier's work order PDF (only produced for suppliers with a work order template; harmless otherwise)
        this.state = { supplyWorksheets: true, supplyJobFile: false, workOrder: true, updateStatus: true };

        this.allowOk = this.allowOk.bind(this);
        this.getBody = this.getBody.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.onClose = this.onClose.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.onChangeSupplyJobFile = this.onChangeSupplyJobFile.bind(this);
        this.onChangeSupplyWorksheets = this.onChangeSupplyWorksheets.bind(this);
        this.onChangeWorkOrder = this.onChangeWorkOrder.bind(this);
        this.onUpdateStatus = this.onUpdateStatus.bind(this);

    }


    onUpdateStatus(e) {
        this.setState({ updateStatus: e.checked });

    }
    onChangeSupplyJobFile(e) {
        this.setState({ supplyJobFile: e.checked });

    }


    onChangeSupplyWorksheets(e) {
        this.setState({ supplyWorksheets: e.checked });

    }

    onChangeWorkOrder(e) {
        this.setState({ workOrder: e.checked });
    }

    componentDidMount() {

    }

    getTitle() {

        if (this.props.isPreview)
            return "application_strings.views.mfScheduling.preview";

        return "application_strings.views.mfScheduling.release";
    }

    allowOk() {
        return this.state.supplyJobFile || this.state.supplyWorksheets || this.state.workOrder;
    }

    onClose(e) {
        this.props.onClose({ ...e, supplyJobFile: this.state.supplyJobFile, supplyWorksheets: this.state.supplyWorksheets, workOrder: this.state.workOrder, updateStatus: this.props.isPreview ? false : this.state.updateStatus });
    }

    getBody() {


        const user = UserService.getUser();

        return <Row >
            <Col md={12}>
                {!this.props.isPreview && <Row>
                    <Col md={12}>
                        <AccentCheckUnbound tagName={"updateStatus"} defaultValue={true} onChange={this.onUpdateStatus} label="application_strings.views.mfScheduling.updateStatus" style={{ marginTop: "20px" }} />
                    </Col>
                </Row>}
                <Row>
                    <Col md={12}>
                        <AccentCheckUnbound tagName={"downloadSupplyWorksheets"} defaultValue={true} onChange={this.onChangeSupplyWorksheets} label="application_strings.views.mfScheduling.downloadSupplyWorksheets" style={{ marginTop: "20px" }} />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <AccentCheckUnbound tagName={"downloadWorkOrder"} defaultValue={true} onChange={this.onChangeWorkOrder} label="application_strings.views.mfScheduling.downloadWorkOrder" style={{ marginTop: "20px" }} />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <AccentCheckUnbound tagName={"dowloadSupplyJobFile"} defaultValue={false} onChange={this.onChangeSupplyJobFile} label="application_strings.views.mfScheduling.dowloadSupplyJobFile" style={{ marginTop: "20px" }} />
                    </Col>
                </Row>
            </Col>
        </Row>;

    }



    render() {


        return <AccentDialog
            headerContent={t(this.getTitle())}
            maxWidth={ 600}
            onClose={this.props.onClose}
            actionsContent={[
                <AccentButton key="2" disabled={!this.allowOk()} tagName="okBtn" onClick={this.onClose}>{t("application_strings.application.buttons.ok")}</AccentButton>
            ]}
        >
            {this.getBody()}
        </AccentDialog>;
    }
}
